import { Button, HStack, Image, Progress, Spacer, Text, VStack } from '@chakra-ui/react';
import { IBook } from '@partiu/api/types';
import { useState } from 'react';
import { FaChevronRight } from 'react-icons/fa';
import { SectionTitle } from '../../../../../packages/ui/components/atoms/Title';
import { useOpenBook } from '../../contexts/BookContext';

export function CurrentBook() {
  const { openBook } = useOpenBook();
  const [book, setBook] = useState<IBook & { progress: string }>();

  if (!book) return null;

  return (
    <VStack align="flex-start" w={'100%'} padding={'0px 5%'}>
      <VStack
        boxShadow={'rgba(100, 100, 90, 0.2) 0px 7px 10px 0px'}
        padding={'15px'}
        borderRadius={'10px'}
        border="1px solid #ededed"
        align={'flex-start'}
        cursor={'pointer'}
        w={{ base: '100%', lg: '450px' }}
        onClick={() => openBook(book)}
      >
        <HStack width={'100%'} spacing={4} justify={'stretch'} align={'stretch'}>
          <Image
            borderRadius={'5px'}
            objectFit={'cover'}
            src={book.cover}
            aspectRatio={0.8}
            width={{ base: '80px', lg: '120px' }}
          />
          <VStack width={'100%'} align={'flex-start'} justify={'flex-start'}>
            <SectionTitle overflowX={'clip'} textOverflow={'ellipsis'} color="black">
              {book.title}
            </SectionTitle>
            <Text>{book.author}</Text>
            <Spacer />
            <HStack w={'95%'}>
              <VStack w="100%" align={'flex-start'}>
                <Text fontSize={'10px'}>{book.progress}% Concluído</Text>
                <Progress
                  minW={{ base: '0px', lg: '150px' }}
                  colorScheme="green"
                  borderRadius={'10px'}
                  hasStripe
                  w={'90%'}
                  value={parseInt(book.progress)}
                />
              </VStack>
              <Spacer />
              <Button
                fontSize={{ base: '11px', lg: '12px' }}
                height={'fit-content'}
                w={'50px'}
                _hover={{}}
                marginTop={'auto'}
                color="primaryColor"
                variant={'ghost'}
                rightIcon={<FaChevronRight />}
              >
                Continuar
              </Button>
            </HStack>
          </VStack>
        </HStack>
      </VStack>
    </VStack>
  );
}
